import { render, staticRenderFns } from "./PackageCards.vue?vue&type=template&id=7ba22272"
import script from "./PackageCards.vue?vue&type=script&lang=js"
export * from "./PackageCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports